import { Button, CircularProgress } from "@mui/material";
import { ReactNode } from "react";

interface AppButtonProps {
  children: ReactNode;
  onClick?: () => void;
  type?: "button" | "submit";
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  variant?: "text" | "outlined" | "contained";
  color?: "primary" | "error" | "success" | "warning" | "inherit";
  startIcon?: ReactNode;
}

const AppButton = ({
  children,
  onClick,
  type = "button",
  disabled = false,
  loading = false,
  fullWidth = false,
  variant = "contained",
  color = "primary",
  startIcon,
}: AppButtonProps) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      variant={variant}
      color={color}
      startIcon={!loading ? startIcon : undefined}
      sx={{
        minHeight: 44,
        px: 2.5,
      }}
    >
      {loading ? <CircularProgress size={22} color="inherit" /> : children}
    </Button>
  );
};

export default AppButton;
